import React from "react";
import { Handle, Position } from "@xyflow/react";
import { FaCodeBranch } from "react-icons/fa";

export default function AutomationConditionNode({ data, selected }) {
  return (
    <div className={`rounded-xl border-2 bg-surface-card shadow-sm min-w-[220px] transition-shadow ${selected ? "border-purple-500 shadow-md" : "border-surface-border"}`}>
      <Handle type="target" position={Position.Top} className="!w-3 !h-3 !bg-purple-500 !border-2 !border-white" />
      <div className="flex items-center gap-2 px-3 py-2 rounded-t-[10px]" style={{ background: "linear-gradient(135deg, #7c3aed, #8b5cf6)" }}>
        <FaCodeBranch size={10} className="text-white" />
        <span className="text-xs font-semibold text-white">Condition</span>
      </div>
      <div className="px-3 py-2.5">
        {data.variable ? (
          <p className="text-xs text-ink-primary font-medium">
            {data.variable} {data.operator || "equals"} {data.value || "?"}
          </p>
        ) : (
          <p className="text-xs text-ink-muted italic">Set condition...</p>
        )}
      </div>
      <div className="flex justify-between px-3 pb-2">
        <div className="relative">
          <Handle type="source" position={Position.Bottom} id="yes" className="!w-3 !h-3 !bg-green-500 !border-2 !border-white" style={{ left: "30%" }} />
          <span className="text-2xs text-green-600 font-medium">Yes</span>
        </div>
        <div className="relative">
          <Handle type="source" position={Position.Bottom} id="no" className="!w-3 !h-3 !bg-red-500 !border-2 !border-white" style={{ left: "70%" }} />
          <span className="text-2xs text-red-600 font-medium">No</span>
        </div>
      </div>
    </div>
  );
}
